


























import { DateTime } from 'luxon';
import { max, min } from 'd3-array';
import Spinner from 'vue-simple-spinner';
import API from '../api/api';
import Vue from 'vue';
import EditorStage1 from '../components/EditorStage1.vue';
import EditorStage2 from '../components/EditorStage2.vue';
import 'vue-slider-component/theme/default.css';
import axios from 'axios';
import { firestore } from '../lib/firebase';
interface SourceData {
  rssFeedURL: string | null;
}
interface SourceInfo {
  title: string | null;
  description: string | null;
  thumbnail: string | null;
}
class FeedData {
  public episodes: any[] = [];
  public loaded: boolean = false;
  public earliestEpisodeMillis: number = 0;
  public latestEpisodeMillis: number = 0;

  public clear() {
    this.episodes = [];
    this.earliestEpisodeMillis = 0;
    this.latestEpisodeMillis = 0;
    this.loaded = false;
  }

  public ingest(data: any) {
    this.loaded = false
    this.episodes  = data.episodes
      .map((episode: any) => {
        const dateTime = DateTime.fromISO(episode.published)
        return {
          ...episode,
          dateTime,
          dateTimeMillis: dateTime.toMillis(),
        };
      });
    this.earliestEpisodeMillis = min(this.episodes, (episode: any) => episode.dateTimeMillis);
    this.latestEpisodeMillis = max(this.episodes, (episode: any) => episode.dateTimeMillis);
    this.loaded = true;
  }
}
export default Vue.extend({
  name: 'editorView',
  components: { EditorStage1, EditorStage2, Spinner },
  props: {
    providedid: {
      type: String,
      default: null,
    },
  },
  data(): {
    sourceData: SourceData | null;
    sourceInfo: SourceInfo | null;
    feedData: FeedData;
    editingStage1: boolean;
    loading: boolean;
    loadedPodpastSettings: any;
  } {
    return {
      sourceData: null,
      sourceInfo: null,
      editingStage1: true,
      feedData: new FeedData(),
      loadedPodpastSettings: null,
      loading: true
    };
  },
  computed: {
    publicID(): string | null {
      if (this.providedid && this.providedid.indexOf('$') !== -1) {
        return this.providedid.split('$')[0];
      } else if (this.providedid) {
        return this.providedid;
      } else {
        return null;
      }
    },
    privateID(): string | null {
      if (this.providedid && this.providedid.indexOf('$') !== -1) {
        return this.providedid.split('$')[1];
      } else {
        return null;
      }
    },
  },
  watch: {
    privateID() {
      this.loadOrReload();
    },
    publicID() {
      this.loadOrReload();
    },
  },
  mounted() {
    this.loadOrReload();
  },
  methods: {
    loadOrReload() {
      // This is for loading the basic info about the podpast, and is only done on
      // initial page load or when the url is changed (ie. new page load essentially)
      if (this.publicID !== 'new') {
        this.loading = true
        firestore.collection('podpast').doc(this.publicID + '').get()
          .then(doc => {
            const docData = doc.data() || {}
            console.log({ docData })
            this.updatedSourceData({
              rssFeedURL: docData.rssFeedURL
            })
            this.loadedPodpastSettings = {
              initialTimeMS: docData.initialTimeMS,
              startTimeMS: docData.startTimeMS,
              speedup: docData.speedup
            }
          })
      } else {
        this.loading = false
      }
    },
    updatedSourceData(newSourceData: SourceData) {
      this.sourceData = newSourceData;
      // At this point, will be loading in the basic data from the RSS feed
      if (this.sourceData && this.sourceData.rssFeedURL) {
        // Clear the existing feedData
        this.feedData.clear()
        API.loadFeedData(this.sourceData.rssFeedURL)
          .then((response: any) => {
            if (response.data.successResponse) {
              this.feedData.ingest(response.data.successResponse);
              this.updatedSourceInfo({
                title: response.data.successResponse.title,
                description: response.data.successResponse.description.long,
                thumbnail: response.data.successResponse.image
              })
              this.loading = false
            } else {
              alert('ERROR');
            }
          })
          .catch((error: any) => {
            // tslint:disable-next-line
            console.log({ error });
            alert('Error');
          });
      } else {
        this.feedData.clear();
      }
    },
    updatedSourceInfo(newSourceInfo: SourceInfo) {
      this.sourceInfo = newSourceInfo;
    },
    updatedEditingStage1Status(newStage1EditStatus: boolean) {
      this.editingStage1 = newStage1EditStatus;
    },
  },
});
